export default __webpack_public_path__ + "static/media/mail.59f5c0ba.svg";